import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@app/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from '@app/components/ui/sidebar';
import { UserInfo } from '@app/components/user-info';
import { UserMenuContent } from '@app/components/user-menu-content';
import { useIsMobile } from '@app/hooks/use-mobile';
import { ChevronsUpDown } from 'lucide-react';
import {useAuth} from '@modules/auth/hooks/context/AuthContext';

export function NavUser() {
    const {user} = useAuth();

    const { state } = useSidebar();
    const isMobile = useIsMobile();

    if (!user) return null;

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton size="lg" className="text-sidebar-accent-foreground data-[state=open]:bg-sidebar-accent group">
                            <UserInfo user={user} />
                            <ChevronsUpDown className="ml-auto size-4" />
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
                        align="end"
                        side={isMobile ? 'bottom' : state === 'collapsed' ? 'left' : 'bottom'}
                    >
                        <UserMenuContent user={user} />
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    );
}
